const Streams = [
  { label: "Medical", value: "1" },
  { label: "Non Medical", value: "2" },
  { label: "Commerce", value: "3" },
  { label: "Humanities", value: "4" },
];

export default Streams;
